var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SubpanelStyled', [!_vm.noHeader ? _c('header', [_vm._t("header")], 2) : _vm._e(), _c('main', [_vm.isLoading ? _c('LoadingDots') : _vm._e(), _vm._t("main")], 2), _c('footer', [_vm._t("footer")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }